export function getDurationParts(minutesValue) {
    const roundedMinutes = Math.round(minutesValue)
    let wholeMinutes = Math.floor(minutesValue)
    let seconds = Math.round((minutesValue % 1) * 60)

    if (seconds === 60) {
        wholeMinutes += 1
        seconds = 0
    }

    return { wholeMinutes, roundedMinutes, seconds }
}

export function getDurationLabel({ wholeMinutes, roundedMinutes, seconds }) {
    if (Number.isNaN(wholeMinutes)) return "-"
    if (seconds !== 0) return `${wholeMinutes}m ${seconds}s`
    return `${roundedMinutes}m`
}
